import serialize from 'serialize-javascript';

export function encode(data) {
  return serialize(data, {isJSON: true});
}

export function decode(serializedData) {
    return JSON.parse(serializedData)
}
